/* sb-header.js — header reageert op scrollen (site-breed).
   - De header houdt ALTIJD dezelfde lichte styling (crème balk, Te Papa tekst, goud kicker).
   - Zodra je scrolt: .sb-header--solid → subtiele elevatie-schaduw + de aankondigingsbalk
     klapt vloeiend in (verdwijnt). Bovenaan weer terug: balk klapt weer open.
   - Progressive enhancement: zonder JS toont de header gewoon de lichte styling + balk. */
(function () {
  var header = document.querySelector('.header-wrapper');
  if (!header) return;

  var THRESHOLD = 30; // px scroll voordat de aankondigingsbalk inklapt + schaduw verschijnt
  var ticking = false;

  function update() {
    ticking = false;
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    header.classList.toggle('sb-header--solid', y > THRESHOLD);
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, true);
  update();
})();
